export default "__VITE_ASSET__BdZMm8f0__"